document.addEventListener( 'DOMContentLoaded', function() {
    var splide = new Splide( '.showcase-video-products',{
      perPage: 4,
      drag: 'free',
      focus: 'left',
      perMove: 1,
      snap: true,
      gap: 24,
      breakpoints: {
        1366: {
          perPage: 3.2,
           perMove: 1,
            dots: true,
        },
        1024: {
            perPage: 2.2,
            perMove: 1,
            dots: true,
        },
        640: {
              perPage: 1.2,
              perMove: 1,
              gap: 16,
              dots: true,
          },
        }
    } );
    splide.mount();

    const cardWrappers = document.querySelectorAll('.card-wrapper');

  cardWrappers.forEach(function (videoWrapper) {
    const video = videoWrapper.querySelector('.card-video');
    const playBtn = videoWrapper.querySelector('.play-btn');
    const pauseBtn = videoWrapper.querySelector('.pause-btn');

    // Ensure the video and play/pause buttons exist before attaching event listeners
    if (video && playBtn && pauseBtn) {
      // Mobile: Play the video when the Play button is clicked
      playBtn.addEventListener('click', function () {
        video.play();
        playBtn.style.display = 'none';
        pauseBtn.style.display = 'flex';
      });

      // Mobile: Pause the video when the Pause button is clicked
      pauseBtn.addEventListener('click', function () {
        video.pause();       // Pause the video
        pauseBtn.style.display = 'none'; // Hide the pause button
        playBtn.style.display = 'flex'; // Show the play button
      });

      // Desktop: Hover functionality remains the same
      videoWrapper.addEventListener('mouseover', function () {
        if (video.paused) {
          video.play().then(() => {
            // If play is successful, nothing more needs to be done
          }).catch((error) => {
            // Handle any play errors (e.g., if the play was interrupted)
            console.error('Error playing video:', error);
          });
        }
      });

      videoWrapper.addEventListener('mouseout', function () {
        if (!video.paused) {
          video.pause();       // Pause the video
        }
      });
    }
  });
  } );